// @ts-nocheck



import React, { Component } from 'react';

import isEqual from 'lodash/isEqual';
import notification from 'antd/lib/notification';





import { vehiclePlanStatusEnum } from './../../../../../lib/enum';
import { vehiclePlanApi } from './../../../../../lib/api';

import { notificationLoading } from './../../../../../components/Notifications';


import InnerTable from './InnerTable';
import InnerTableReadOnly from './InnerTableReadOnly';















export default class extends Component {
  state = {
    localLoading: false,
    localData: []
  };

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.data, this.props.data)) {
      this.setState({
        localData: this.props.data
      });
    }
  }

  handleSubmit = async (data) => {
    this.setState({ localLoading: true });
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      await vehiclePlanApi.updateVehicles(data);
      this.setState({ localData: data });
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
      this.setState({ localLoading: false });
    }
  };

  render() {
    const {
      data,
      loading,
      vehiclePlanType,
      readonly,
      vehiclePlanStatus,
      selectedVehicle
    } = this.props;
    const { localLoading, localData } = this.state;
    return readonly ?
    <InnerTableReadOnly
      data={localData}
      loading={loading || localLoading}
      readonly={[
      vehiclePlanStatusEnum.approvement,
      vehiclePlanStatusEnum.approved,
      vehiclePlanStatusEnum.declined].
      includes(vehiclePlanStatus)}
      handleSubmit={this.handleSubmit} /> :


    <>
        <InnerTable
        vehiclePlanType={vehiclePlanType}
        data={data}
        loading={loading}
        selectedVehicle={selectedVehicle} />

      </>;

  }
}
